// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".PackageTypes_packageTypes__3rmH{padding:40px 70px}", "",{"version":3,"sources":["app/propertySettings/PackageTypes/PackageTypes.scss"],"names":[],"mappings":"AAAA,iCACI,iBAAA","file":"PackageTypes.scss","sourcesContent":[".packageTypes {\n    padding: 40px 70px;\n}\n"]}]);
// Exports
exports.locals = {
	"packageTypes": "PackageTypes_packageTypes__3rmH"
};
module.exports = exports;
